import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";
import { useTranslation } from "react-i18next";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

interface PhoneTypeProps {
  phoneType: "mobile" | "telephone";
}

const TextMaskCustom = forwardRef<HTMLInputElement, CustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
      />
    );
  }
);
TextMaskCustom.displayName = "TextMaskCustom";

const PhoneTextField = forwardRef<
  HTMLInputElement,
  Omit<TextFieldProps & PhoneTypeProps, "label" | "placeholder" | "InputProps">
>((props) => {
  const { t } = useTranslation();
  const label =
    props.phoneType === "mobile" ? t("register.cellphoneLabel") : t("register.phoneLabel");
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: TextMaskCustom as never,
        inputProps: {
          mask:
            props.phoneType === "mobile"
              ? "(##) 0 0000-0000"
              : "(##) 0000-0000",
        },
      }}
      color="primary"
      label={label}
      placeholder={
        props.phoneType === "mobile" ? "(00) 0 0000-0000" : "(00) 0000-0000"
      }
      sx={{
        "& .MuiFormLabel-root": {
          color: "primary.main",
        },
        "& .MuiInputBase-input": {
          color: "primary.main",
        },
      }}
    />
  );
});
PhoneTextField.displayName = "PhoneTextField";
export default PhoneTextField;
